/**
 * Apply i18n overrides from CMS
 * 
 * Uses i18next's addResourceBundle to overlay CMS values on top of
 * static translation files without replacing the entire bundle.
 */

import i18n from '../i18n';

/**
 * Apply translation overrides from CMS to the i18n instance
 * @param {string} lng - Language code (en, sv, de, pl)
 * @param {Object} translations - Key-value map of translations from CMS
 * @returns {number} Number of keys applied
 */
export function applyI18nOverrides(lng, translations) {
    if (!translations || typeof translations !== 'object') {
        return 0;
    }

    const keys = Object.keys(translations);
    if (keys.length === 0) {
        return 0;
    }

    // Convert flat key structure to nested for i18next
    // e.g., "header.nav.home" → { header: { nav: { home: "..." } } }
    const nested = {};

    for (const [key, value] of Object.entries(translations)) {
        const parts = key.split('.');
        let current = nested;

        for (let i = 0; i < parts.length - 1; i++) {
            const part = parts[i];
            if (!current[part]) {
                current[part] = {};
            }
            current = current[part];
        }

        current[parts[parts.length - 1]] = value;
    }

    // Add resource bundle with deep merge and overwrite
    // deep=true: merge with existing translations
    // overwrite=true: replace existing keys
    i18n.addResourceBundle(lng, 'translation', nested, true, true);

    if (process.env.NODE_ENV !== 'production') {
        console.log(`[CMS] Applied ${keys.length} i18n overrides for ${lng}`);
    }

    return keys.length;
}

/**
 * Check if i18n is initialized and ready
 * @returns {boolean}
 */
export function isI18nReady() {
    return i18n.isInitialized;
}

export default applyI18nOverrides;
